// Components
// Types
import ObjectCriteria from 'components/ObjectCriteria';
import type { TDynamicAvailability } from '@timeedit/types/lib/types';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';

interface Props {
  dynamicAvailability?: TDynamicAvailability;
  onChange: (updatedValues: Record<string, any>) => void;
  isExpand: boolean;
}

const ObjectCriteriaSection = ({
  dynamicAvailability,
  onChange,
  isExpand,
}: Props) => {
  if (!dynamicAvailability) return null;
  return (
    <TEDrawerSection label="Object criteria">
      <TEInput.Switch
        label="Include abstract objects"
        tooltip="Include abstract objects"
        value={dynamicAvailability.includeAbstractObjects}
        onChange={(value) => onChange({ includeAbstractObjects: value })}
      />
      <br />
      <ObjectCriteria
        impactedObjects={dynamicAvailability.impactedObjects || []}
        objectsOnReservation={dynamicAvailability.objectsOnReservation || []}
        isExpand={isExpand}
        onChange={onChange}
      />
    </TEDrawerSection>
  );
};

export default ObjectCriteriaSection;
